export class ManufacturerPatterns {
    pattern: string;
    mandatory: boolean;
    fileType: string;
    fileSeparator: string;
    roleOfFile: string;
    processType: string;
}